/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseSubDbTableRow } from './DatabaseSubDbTableRow';
import {
    DatabaseSubDbTableRowFromJSON,
    DatabaseSubDbTableRowFromJSONTyped,
    DatabaseSubDbTableRowToJSON,
} from './DatabaseSubDbTableRow';

/**
 * Fertig gerechnet vom Server — Zeilen, Spalten, Sollwerte und Summen.
 * Die Anzeige faerbt nur noch ein.
 * @export
 * @interface DatabaseSubDbTable
 */
export interface DatabaseSubDbTable {
    /**
     * Spaltenueberschriften, in der Reihenfolge der Spalten.
     * @type {Array<string>}
     * @memberof DatabaseSubDbTable
     */
    columns?: Array<string>;
    /**
     * Sollwert je Spalte; leer, wenn keiner eingestellt ist.
     * @type {Array<number>}
     * @memberof DatabaseSubDbTable
     */
    compareValues?: Array<number>;
    /**
     * 
     * @type {Array<DatabaseSubDbTableRow>}
     * @memberof DatabaseSubDbTable
     */
    rows?: Array<DatabaseSubDbTableRow>;
    /**
     * 
     * @type {DatabaseSubDbTableRow}
     * @memberof DatabaseSubDbTable
     */
    sumRow?: DatabaseSubDbTableRow;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseSubDbTable
     */
    lowerIsBetter?: boolean;
}

/**
 * Check if a given object implements the DatabaseSubDbTable interface.
 */
export function instanceOfDatabaseSubDbTable(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSubDbTableFromJSON(json: any): DatabaseSubDbTable {
    return DatabaseSubDbTableFromJSONTyped(json, false);
}

export function DatabaseSubDbTableFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSubDbTable {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columns': !exists(json, 'columns') ? undefined : json['columns'],
        'compareValues': !exists(json, 'compareValues') ? undefined : json['compareValues'],
        'rows': !exists(json, 'rows') ? undefined : ((json['rows'] as Array<any>).map(DatabaseSubDbTableRowFromJSON)),
        'sumRow': !exists(json, 'sumRow') ? undefined : DatabaseSubDbTableRowFromJSON(json['sumRow']),
        'lowerIsBetter': !exists(json, 'lowerIsBetter') ? undefined : json['lowerIsBetter'],
    };
}

export function DatabaseSubDbTableToJSON(value?: DatabaseSubDbTable | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columns': value.columns,
        'compareValues': value.compareValues,
        'rows': value.rows === undefined ? undefined : ((value.rows as Array<any>).map(DatabaseSubDbTableRowToJSON)),
        'sumRow': DatabaseSubDbTableRowToJSON(value.sumRow),
        'lowerIsBetter': value.lowerIsBetter,
    };
}

